import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SToastViewport } from '@chargebee/sting-react';
import { ErrorPage } from '@bbkAdminComponents/app-layout/error';
import { DesignerLocaleRouteObserver } from '@bbkAdminComponents/designer/designer-locale-route-observer';
import { InfoModalContainer } from '@bbkAdminComponents/info-dialog';
import { persistor, store } from '@bbkAdminRedux/redux';
import { AdminApp } from '@bbkAdminRouter/admin-app';
import { useDetectIE } from '@bbkAdminUtils/detect-ie';
import { BrowserRouter, CompatRouter } from '@bbkShared/react-router';

import '@chargebee/sting-react/sting-react.css';

export const Main: React.FC = () => {
  const isIE = useDetectIE();

  if (isIE) {
    return (
      <ErrorPage message="Sorry, IE is not supported.  Please try Chrome, Firefox, or Safari" />
    );
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <CompatRouter>
            <DesignerLocaleRouteObserver />
            <InfoModalContainer>
              <AdminApp />
            </InfoModalContainer>
            <SToastViewport position="bottom-right" />
          </CompatRouter>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};
